export var no = {
    required: 'Påkrevd',
    deprecated: 'Foreldet',
    deprecated_and_sunset_on: 'Denne operasjonen er foreldet og vil bli avviklet den ${1}.',
    stability_experimental: 'Eksperimentell',
    stability_alpha: 'Alfa',
    stability_beta: 'Beta',
    copy_to_clipboard: 'Kopier til utklippstavle',
    copied: 'Kopiert',
    no_content: 'Ingen innhold',
    unresolved_reference: 'Uavklart referanse',
    circular_reference: 'Sirkulær referanse',
    read_only: 'Skrivebeskyttet',
    write_only: 'Kun skriving',
    optional: 'Valgfri',
    min: 'Min',
    max: 'Maks',
    nullable: 'Kan være null',
    body: 'Brødtekst',
    payload: 'Nyttelast',
    headers: 'Overskrifter',
    authorizations: 'Autorisasjoner',
    responses: 'Responser',
    path_parameters: 'Sti-parametere',
    query_parameters: 'Forespørselsparametere',
    header_parameters: 'Header-parametere',
    attributes: 'Attributter',
    test_it: 'Test det',
    information: 'Informasjon',
    success: 'Suksess',
    redirect: 'Viderekobling',
    error: 'Feil',
    show: 'Vis',
    hide: 'Skjul',
    available_items: 'Tilgjengelige elementer',
    child_attributes: 'Barneattributter',
};
